/** A map pin: an in-person training, or a venue. */
export const PinIcon: React.FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
	>
		<path
			d="M8 14.5s5-4.2 5-8a5 5 0 10-10 0c0 3.8 5 8 5 8z"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<circle cx="8" cy="6.5" r="1.8" stroke="currentColor" strokeWidth="1.5" />
	</svg>
)
